import { render, staticRenderFns } from "./purchaseDiscount.vue?vue&type=template&id=6450d0d8"
import script from "./purchaseDiscount.vue?vue&type=script&lang=js"
export * from "./purchaseDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports